// فایل: src/components/AddTaskForm.tsx
import React, { useState } from "react";
import { faTrash, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { deleteTask } from "../api/tasks"; // اطمینان از مسیر صحیح

interface Props {
  projectId: number;
  onSubmit: (title: string, description?: string) => void;
}

export default function AddTaskForm({ projectId, onSubmit }: Props) {
  // state ایجاد
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  // state حذف
  const [deleteTaskId, setDeleteTaskId] = useState<string>(""); // رشته برای کنترل ورودی
  const [deleting, setDeleting] = useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;
    onSubmit(title.trim(), description.trim() || undefined);
    setTitle("");
    setDescription("");
  };

  const handleDelete = async () => {
    const parsedId = Number(deleteTaskId);
    if (!parsedId || isNaN(parsedId)) {
      alert("شناسه تسک معتبر نیست");
      return;
    }
    try {
      setDeleting(true);
      await deleteTask(projectId, parsedId);
      alert("تسک حذف شد");
      setDeleteTaskId("");
    } catch (err: any) {
      alert(err?.message ?? "خطا در حذف تسک");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={{ marginTop: 12 }}>
      {/* فرم ایجاد تسک */}
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            padding: 12,
            border: "1px solid #ddd",
            borderRadius: 8,
          }}
        >
          <input
            placeholder="Task title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={{ flex: 1 }}
          />

          <input
            placeholder="Short description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ flex: 1 }}
          />

          <button type="submit" style={{ alignSelf: "center" }}>
            <FontAwesomeIcon icon={faSave} fontSize="20" /> ذخیره
          </button>
        </div>
      </form>

      {/* بخش حذف تسک 
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          padding: 12,
          marginTop: 12,
          border: "1px solid #f2dede",
          borderRadius: 8,
          background: "#fcf8e3",
        }}
      >
        <label style={{ fontWeight: 600 }}>حذف تسک</label>
        <input
          placeholder="Task ID برای حذف"
          value={deleteTaskId}
          onChange={(e) => setDeleteTaskId(e.target.value)}
          inputMode="numeric"
        />
        <button
          type="button"
          onClick={handleDelete}
          disabled={deleting}
          style={{ alignSelf: "center", color: "white", background: "#d9534f", padding: "6px 12px", borderRadius: 6 }}
        >
          <FontAwesomeIcon icon={faTrash} fontSize="20" />{" "}
          {deleting ? "در حال حذف..." : "حذف"}
        </button>
      </div>*/}
    </div>
  );
}
